var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/welcome2.eb3f0ae2.png","uri@2x": __webpack_public_path__ + "static/media/welcome2.43dfc737.png","uri@3x": __webpack_public_path__ + "static/media/welcome2.146a19e6.png",
    width: 201,
    height: 201
});